var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"getway-record page-padding flex-auto"},[_c('ioc-table',{ref:"crud",attrs:{"data":_vm.tableData,"option":_vm.option,"page":_vm.page},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange,"search-reset":_vm.searchData,"search-change":_vm.searchData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }